<template>
  <div class="col-sm-10 col-md-10">
    <div class="row-col">

      <!-- outlet list -->
      <div class="col-sm-4 col-md-4 light bg b-r">
        <div class="row-col">
          <div class="p-a-xs b-b">
            <div class="input-group">
              <span class="input-group-addon no-border no-bg"><i class="fa fa-search"/></span>
              <input 
                v-model="search" 
                type="text" 
                class="form-control no-border no-bg" 
                placeholder="Search Outlet">
            </div>
          </div>
          <div class="row-row">
            <div class="row-body scrollable hover">
              <div class="row-inner">
                <div class="list inset">

                  <div 
                    v-for="outlet in outletList" 
                    :key="outlet.id" 
                    class="list-item pointer" 
                    @click="showForm(outlet)">
                    <div class="list-left">
                      <span class="w-40 avatar">
                        <img 
                          :src="getOutletImage(outlet)" 
                          class="img-circle">
                      </span>
                    </div>
                    <div class="list-body">
                      {{ outlet.name }}
                    </div>
                  </div>

                  <p 
                    v-show="!outletList.length && !loading" 
                    class="text-muted p-a-md">
                    <i>No outlet found</i>
                  </p>

                  <loading-spinner v-show="loading"/>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <outlet-target-form :outlet="outlet"/>
    <!-- form -->
   
    </div>
  </div>
</template>
<script>
import outletTargetForm from './outlet-target-form.vue';
import { Event } from '../../../event-bus';

export default {
    components: {
        outletTargetForm,
    },
    data() {
        return {
            loading: true,
            outlets: [],
            search: '',
            outlet: {},
        };
    },
    computed: {
        outletList() {
            return this.getFilteredOutletList();
        },
    },
    mounted() {
        this.getOutletList();
    },
    methods: {
        getOutletList() {
            let api = Laroute.route('franchise.vue.outlets');
            this.$http.get(api).then(res => {
                this.outlets = res.data.data;
                this.loading = false;
                this.endLoading('load settings');
            });
        },
        getOutletImage(outlet) {
            if (outlet.media_urls.length) {
                return outlet.media_urls[0].s512;
            }

            return '/img/slurp-500.png';
        },
        getFilteredOutletList() {
            return this.outlets.filter(o => {
                return (
                    o.name
                        .toLowerCase()
                        .indexOf(this.search.toLowerCase().trim()) > -1
                );
            });
        },
        showForm(outlet) {
            this.outlet = outlet;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/setting/target/outlet-target.vue